import { SubAgentLimitExceedCard } from '../SubAgentLimitExceedCard';
import * as React from 'react';

import { PublicationLayout } from '../PublicationLayout/PublicationLayout';

export const SubAgentLimitExceed = () => {
  return <PublicationLayout content={<SubAgentLimitExceedCard />} />;
};
